







































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import ZoomableImage from '../../ZoomableImage/ZoomableImage.vue'
import FileApi from "../logic/file-api";

@Component({
  components: {
    ZoomableImage
  }
})
export default class FileDescriptorList extends Vue {
  @Prop() values!: Array<string>

  @Prop() targetId!: string | number

  @Prop({ type: Boolean, default: false }) saveable!: boolean

  @Prop({ type: Boolean, default: false }) removable!: boolean

  @Emit()
  removeFile(descriptor: string) {
    return descriptor
  }

  fileApi = new FileApi()
}
